<template lang="pug">
  SmartTable.table(:name="`locker-${mode}-list`" v-bind="table", v-model="tableData" ref="table")
    template(v-slot:default="slotProps")
      TableRow(v-bind="slotProps")
        template(v-slot:employee.name="{ columnValue, rowItem, index }")
          span.no-wrap {{ columnValue }}

        template(v-slot:employee.company.name="{ columnValue, rowItem, index }")
          span.no-wrap {{ columnValue }}

        template(v-slot:lockedAt="{ columnValue, rowItem, index }")
          span.no-wrap {{ columnValue | date }}

        template(v-slot:kind="{ columnValue, rowItem, index }")
          span.fs-19(
            v-if="lockerStates[columnValue]"
            :class="lockerStates[columnValue].classes"
            :title="lockerStates[columnValue].text"
            :style="{color: lockerStates[columnValue].color}")

          span.fs-19(v-else-if="columnValue === 'not_locked'")

          span.fs-19(v-else)
            | {{ columnValue }}

    template(v-slot:detailsBox="{item}")
      .details
        DBLabel(:title="$ws('employee') + ':'" :body="item.employee.name")
        DBLabel(title="data do travamento:" v-if="item.lockedAt")
         template(v-slot:body)
           | {{ item.lockedAt | date }}
        span(v-else)

        DBLabel(v-if="lockerStates[item.kind]" title="status do travamento:" :body="lockerStates[item.kind].text")

        .operations
          Accordion(:startOpen="false" v-if="item.operations && item.operations.length")
            template(slot="heading")
              span.fs-15(style="text-align: center;") histórico das operações

            template
              .container
                .op(v-for="op in item.operations")
                  span {{ op.date | date }}
                  span(v-if="op.confirmation == true") Confirmado por
                  span(v-if="op.confirmation == false") Cancelado por
                  span(v-if="op.confirmation == undefined") {{ op.title }} por
                  span {{ op.user }}
                  .observation(v-if="op.observation")
                    | observação: {{ op.observation }}

        .buttons
          span(style="margin-right: 30px")
            PButton(color="primary" size="md" @click="goToEmployeeSheet(item)")
              span.icon-ptt-icons-folha.to-click

          template(v-if="mode === 'notLocked'")
            PButton(color="success" size="md" v-if="permissions.confirmLock"
            @click="executeAction('lock', item)" :loading="executingAction.lock")
              | iniciar travamento
            PButton(color="info" size="md" v-if="permissions.doUnilateralLock"
            @click="executeAction('lockUnilateral', item)" :loading="executingAction.lockUnilateral")
              | travar unilateralmente

          template(v-else-if="mode === 'rejected'")
            PButton(color="success" size="md" v-if="permissions.confirmLock"
            @click="executeAction('confirm', item)" :loading="executingAction.confirm")
              | confirmar

          template(v-else-if="mode === 'confirmed'")
            PButton(color="danger" size="md" v-if="permissions.rejectLock"
            @click="executeAction('reject', item)" :loading="executingAction.reject")
              | rejeitar

          template(v-else-if="mode === 'locked'")
            PButton(color="warning" size="md" v-if="permissions.doUnlocker"
            @click="executeAction('unlock', item)" :loading="executingAction.unlock")
              | destravar

</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { lockerStates } from 'src/components/Sheets/Sheet/sheetUtils.js'

export default {
  name: 'LockTable',
  props: {
    mode: {required: true, type: String},
    permissions: {required: true, type: Object}
  },
  data () {
    return {
      lockerStates,
      executingAction: {
        lock: false,
        confirm: false,
        reject: false,
        lockUnilateral: false,
        unlock: false
      }
    }
  },
  computed: {
    ...mapState('locker', ['notLocked', 'locked', 'rejected', 'confirmed', 'loading']),
    table () {
      const headersPerMode = {
        notLocked: [
          {column: this.$ws('employee'), field: 'employee.name', width: '2fr'},
          {column: 'local de trabalho', field: 'employee.company.name', width: '2fr'}
        ],
        rejected: [
          {column: 'status', field: 'kind', width: '0.5fr'},
          {column: this.$ws('employee'), field: 'employee.name', width: '1.5fr'},
          {column: 'local de trabalho', field: 'employee.company.name', width: '2fr'}
        ],
        confirmed: [
          {column: 'status', field: 'kind', width: '0.5fr'},
          {column: this.$ws('employee'), field: 'employee.name', width: '1.5fr'},
          {column: 'local de trabalho', field: 'employee.company.name', width: '2fr'}
        ],
        locked: [
          {column: 'status', field: 'kind', width: '0.6fr'},
          {column: this.$ws('employee'), field: 'employee.name', width: '2fr'},
          {column: 'local de trabalho', field: 'employee.company.name', width: '2fr'},
          {
            column: 'data do travamento',
            field: 'lockedAt',
            width: '1fr',
            mask: '##/##/####',
            placeholder: '01/01/2019',
            filterFunction: ({search, item}) => {
              return this.formatDate(item.lockedAt).includes(search)
            }
          }
        ]
      }

      return {
        headerItems: headersPerMode[this.mode],
        config: {
          perPage: 10,
          startFocusedSearch: 'employee.name',
          defaultSortField: 'employee.name',
          defaultColumnSearch: 'employee.name',
          detailsBox: {
            numberColumnsKeep: this.mode === 'notLocked' ? 1 : 2
          }
        }
      }
    },
    tableData: {
      get () {
        return {
          loading: this.loading,
          loaded: this[this.mode]
        }
      }
    }
  },
  methods: {
    goToEmployeeSheet (locker) {
      const employee = this.$store.state.common.employees.items.find(i => i.id === locker.employee.id)

      this.$router.goToTimesheet(
        new Date(locker.year, locker.month - 1, 1), employee, null, true
      )
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    close () {
      this.$refs.table.closeDetailsBox()
    },
    async executeAction (operation, locker) {
      this.executingAction[operation] = true

      await this.$store.dispatch('locker/executeAction', {
        viewMode: this.mode, applyTo: locker.employee, operation
      })
      this.close()
      this.$store.dispatch('locker/loadData', {mode: this.mode})

      this.executingAction[operation] = false
    }
  },
  filters: {
    date (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  }
}
</script>

<style scoped lang="scss">
.details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 30px;

  .operations {
    grid-column: 1/3;

    .container {
      max-height: 300px;
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 10px;

      .op {
        display: grid;
        grid-template-columns: 0.8fr 1fr 1fr 1fr;
        padding-top: 4px;
        padding-bottom: 4px;
        grid-column-gap: 10px;

        &:not(:last-child) {
          border-bottom: 1px solid lightgrey;
        }
      }
    }
  }

  .buttons {
    grid-column: 1/3;
  }
}
</style>
